import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/components/login';
// 首页
import appIndex from '@/components/index.vue';
// CRM-客户信息查询
import customerCheck from '@/components/customerCheck';
// CRM-任务管理查询
import taskManage from '@/components/taskManage';
import isTruetask from '@/components/taskManage/isTruetask';
import myTask from '@/components/taskManage/myTask';
import taskDetail from '@/components/taskManage/taskDetail';
import addTask from '@/components/taskManage/addTask';

// CRM-客户管理相关
import clientManage from '@/components/clientManage';
import allClient from '@/components/clientManage/allClient';
import myClient from '@/components/clientManage/myClient';
// CRM-服务推荐相关
import serveRecd from '@/components/serveRecd';
import ProductRecd from '@/components/serveRecd/ProductRecd'; // 商品推荐
import activityRecd from '@/components/serveRecd/activityRecd'; // 活动推荐
import storeRecd from '@/components/serveRecd/storeRecd'; // 商家推荐
// CRM-订单查询
import orderQuery from '@/components/orderQuery';
import clientOrder from '@/components/orderQuery/clientOrder'; // 客户订单
import allOrder from '@/components/orderQuery/allOrder'; // 全部订单
import orderDetail from '@/components/orderQuery/orderDetail'; // 全部订单
// CRM-建行双签用户管理
import jianhangUser from '@/components/jianhangUser';
import userLabelManage from '@/components/customerCheck/userLabelManage';
import userLabelCheck from '@/components/customerCheck/userLabelCheck';

// 角色及权限
import roleAndPermission from '@/components/roleAndPermission';
import roleManage from '@/components/roleAndPermission/roleManage'; // 角色管理
import accountManage from '@/components/roleAndPermission/accountManage'; // 账号管理

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '/app',
      name: 'appIndex',
      component: appIndex,
      children: [
        {
          path: 'customer',
          name: 'customerCheck',
          component: customerCheck
        },
        {
          path: 'clientManage',
          name: 'clientManage',
          component: clientManage,
          children: [
            {
              path: 'myClient',
              name: 'myClient',
              component: myClient
            },
            {
              path: 'allClient',
              name: 'allClient',
              component: allClient
            }
          ]
        },
        {
          path: 'taskManage',
          name: 'taskManage',
          component: taskManage,
          children: [
            {
              path: 'isTruetask',
              name: 'isTruetask',
              component: isTruetask
            },
            {
              path: 'myTask',
              name: 'myTask',
              component: myTask
            },
            {
              path: 'addTask',
              name: 'addTask',
              component: addTask
            },
            {
              path: 'taskDetail',
              name: 'taskDetail',
              component: taskDetail
            }
          ]
        },
        {
          path: 'serveRecd',
          name: 'serveRecd',
          component: serveRecd,
          children: [
            {
              path: 'ProductRecd',
              name: 'ProductRecd',
              component: ProductRecd
            },
            {
              path: 'activityRecd',
              name: 'activityRecd',
              component: activityRecd
            },
            {
              path: 'storeRecd',
              name: 'storeRecd',
              component: storeRecd
            }
          ]
        },
        {
          path: 'manage',
          name: 'roleAndPermission',
          component: roleAndPermission,
          children: [
            {
              path: 'role',
              name: 'roleManage',
              component: roleManage
            },
            {
              path: 'account',
              name: 'accountManage',
              component: accountManage
            }
          ]
        },
        {
          path: 'orderQuery',
          name: 'orderQuery',
          component: orderQuery,
          children: [
            {
              path: 'clientOrder',
              name: 'clientOrder',
              component: clientOrder
            },
            {
              path: 'allOrder',
              name: 'allOrder',
              component: allOrder
            },
            {
              path: 'orderDetail',
              name: 'orderDetail',
              component: orderDetail
            }
          ]
        },
        {
          path: 'jianhangUser',
          name: 'jianhangUser',
          component: jianhangUser
        },
        {
          path: 'userLabelManage',
          name: 'userLabelManage',
          component: userLabelManage
        },
        {
          path: 'userLabelCheck',
          name: 'userLabelCheck',
          component: userLabelCheck
        }
      ]
    },
    {
      path: '*',
      name: 'frame',
      component: appIndex
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js